<div
  *ngIf="
    event?.data?.event_type != MAADHANTHIRA_SANDHA &&
    event?.data?.event_type != POTHU_VARAVU_SELAVU &&
    event?.data?.event_type != PORUPALAR_NIYAMANA_THEERMANAM &&
    event?.data?.event_type != THOGUTHI_KALANTHAIVU
  "
  class="card-preview"
>
  <mat-icon
    matTooltip="{{ 'EVENT_STATUS.Approved' | translate }}"
    *ngIf="event?.data?.status == 1"
    class="status-icon text-success"
    >check_circle</mat-icon
  >
  <mat-icon
    matTooltip="{{ 'EVENT_STATUS.Rejected' | translate }}"
    *ngIf="event?.data?.status == 0"
    class="status-icon text-danger"
    >block</mat-icon
  >
  <mat-icon
    matTooltip="{{ 'EVENT_STATUS.Pending' | translate }}"
    *ngIf="event?.data?.status == 2"
    class="status-icon text-warning"
    >help</mat-icon
  >

  <div
    [ngClass]="event?.data?.event_deleted == 1 ? 'disable' : ''"
    class="fuse-card"
  >
    <label style="padding: 6px">#{{ barracks[event?.data?.barrack_id] }}</label>

    <div
      class="p-16 pb-0"
      fxLayout="row wrap "
      fxLayoutGap="32px"
      fxLayoutAlign="space-between center"
    >
      <div class="pr-16 top hash" fxLayout="column">
        <div
          *ngIf="
            event?.data?.status == -1 &&
            (event.data.enable_edit_btn ||
              event.data.enable_delete_btn ||
              event.data.enable_copy_btn)
          "
          class="bar"
        >
          <button
            class="menu"
            mat-icon-button
            [matMenuTriggerFor]="menu"
            aria-label="Example icon-button with a menu"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button
              mat-menu-item
              *ngIf="event.data.enable_edit_btn"
              (click)="event.data.editEvent('edit', event)"
            >
              <mat-icon>mode_edit</mat-icon>
              <span>திருத்து</span>
            </button>
            <button
              (click)="event.data.deleteEvent('edit', event)"
              mat-menu-item
              *ngIf="event.data.enable_delete_btn"
            >
              <mat-icon>delete</mat-icon>
              <span>நீக்கு</span>
            </button>
            <button mat-menu-item *ngIf="event.data.enable_copy_btn">
              <mat-icon>file_copy</mat-icon>
              <span>{{ "Copy File" | translate }}</span>
            </button>
          </mat-menu>
        </div>

        <div class="h2 nigalvu">#{{ event?.data?.event_id }}</div>
        <div class="h3 secondary-text">
          <button mat-button class="blue-A700 constens" color="primary">
            {{ event?.data?.event_place[0]?.place_data.place_name }}
          </button>
        </div>

        <div class="mt-4 make">
          உருவாக்கப்பட்டது :{{ event?.data?.created_member_name }} #{{
            event?.data?.event_entered_userId
          }}
          {{ event?.data?.event_created_time | date : "dd/MM/yyyy hh:mm a" }}
        </div>
        <div class="mt-4 make">
          மாற்றப்பட்டது:{{ event?.data?.updated_member_name }} #{{
            event?.data?.event_updated_user_id
          }}
          {{ event?.data?.event_update_time | date : "dd/MM/yyyy hh:mm a" }}
        </div>
      </div>

      <div fxLayout="column" class="top second">
        <div class="h1">{{ event?.data?.event_title }}</div>
        <br />
        <div class="h2">
          {{ event?.data?.event_start_time | date : "dd/MM/yyyy hh:mm a" }}
          -
          {{ event?.data?.event_end_time | date : "dd/MM/yyyy hh:mm a" }}
        </div>
        <div class="mb-4 mt-12">
          <button
            mat-flat-button
            style="background-color: green; color: #fff; width: 165px"
            [disabled]="!event.data.enable_contribution_btn"
            (click)="
              event.data.enable_contribution_btn
                ? event.data.openContribution(event)
                : null
            "
            color="primary"
            class="mr-4 contri"
          >
            {{
              event?.data?.totalContribution
                | currency : "INR" : "symbol" : "1.0-0"
            }}
          </button>
          <button
            class="mr-4"
            [disabled]="!event.data.enable_expense_btn"
            mat-flat-button
            style="background-color: red; color: #fff; width: 165px"
            (click)="
              event.data.enable_expense_btn
                ? event.data.openExpense(event)
                : null
            "
            color="primary"
          >
            {{
              event?.data?.totalExpense | currency : "INR" : "symbol" : "1.0-0"
            }}
          </button>
        </div>
      </div>

      <div class="top third" fxLayout="column">
        <div class="bar1">
          <button
            *ngIf="
              event?.data?.status == -1 &&
              (event.data.enable_edit_btn ||
                event.data.enable_delete_btn ||
                event.data.enable_copy_btn)
            "
            class="menu"
            mat-icon-button
            [matMenuTriggerFor]="menu"
            aria-label="Example icon-button with a menu"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button
              mat-menu-item
              *ngIf="event.data.enable_edit_btn"
              (click)="event.data.editEvent('edit', event)"
            >
              <mat-icon>mode_edit</mat-icon>
              <span>திருத்து</span>
            </button>
            <button
              (click)="event.data.deleteEvent('edit', event)"
              mat-menu-item
              *ngIf="event.data.enable_delete_btn"
            >
              <mat-icon>delete</mat-icon>
              <span>நீக்கு</span>
            </button>
            <button mat-menu-item *ngIf="event.data.enable_copy_btn">
              <mat-icon>file_copy</mat-icon>
              <span>{{ "Copy File" | translate }}</span>
            </button>
          </mat-menu>
        </div>

        <br />
        <div class="icon">
          <button
            (click)="event.data.finalAction('question', event)"
            *ngIf="event.data.enable_question_btn"
            mat-mini-fab
            class="light-blue-A700 mr-4"
          >
            <mat-icon>help_outline </mat-icon>
          </button>

          <button
            (click)="event.data.finalAction('approve', event)"
            *ngIf="event.data.enable_approve_btn"
            mat-mini-fab
            class="green-600 mr-4"
          >
            <mat-icon>check_circle </mat-icon>
          </button>

          <button
            (click)="event.data.finalAction('reject', event)"
            *ngIf="event.data.enable_reject_btn"
            mat-mini-fab
            class="warn"
          >
            <mat-icon>not_interested</mat-icon>
          </button>
          <!-- <button
            *ngIf="event.data.enable_un_approve_btn"
            title="Un Approve"
            mat-mini-fab
            color="white"
            (click)="event.data.unApprove('unapprove', event)"
          >
            <img
              style="width: '24px'; height: '24px'"
              src="/assets/images/event_approve_restore.png"
            />
          </button> -->
        </div>
      </div>
    </div>

    <div class="h3 secondary-text">
      <button
        mat-button
        color="primary"
        *ngFor="let path of event?.data?.event_places"
      >
        {{ path }}
      </button>
    </div>

    <div class="pb-4" fxLayout="row" fxLayoutAlign="center center">
      <div class="expand">
        <mat-icon
          (click)="event.data.expandEvent(event)"
          style="cursor: pointer; color: skyblue; font-size: 30px"
        >
          keyboard_arrow_down</mat-icon
        >
      </div>
    </div>

    <div *ngIf="event.expended" class="hidefile">
      <mat-card *ngIf="event.data.enable_details" class="example-card cardstle">
        <mat-card-header class="accent">
          <mat-card-title class="mt-4"
            >விவரம்
            <span style="font-size: 15px"
              >(குறைந்தது 50 எழுத்துகள் இருக்க வேண்டும். ஆங்கிலம் -> தமிழ்
              தட்டச்சுக்கு
              <span style="cursor: pointer" (click)="tamiltype()"
                >www.tamiltyping.in/</span
              >
              பயன்படுத்தி கொள்ளவும்.)
            </span></mat-card-title
          >
        </mat-card-header>
        <mat-card-content class="primary-50">
          <div class="p-12">
            <div
              style="white-space: pre-line"
              *ngIf="event?.data?.event_description"
            >
              {{ event?.data?.event_description }}
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card
        *ngIf="event.data.enable_spearhead_btn"
        class="example-card cardstle"
      >
        <mat-card-header class="accent">
          <mat-card-title class="mt-4">{{
            event?.data?.event_subgroup?.param_1 || "முன்னெடுத்தவர்கள்"
              | translate
          }}</mat-card-title>
        </mat-card-header>
        <mat-card-content class="primary-50">
          <div
            fxLayout="row flex-wrap"
            class="p-16 pt-0 line-height-1.75 mr-12 ml-12 mb-12 mt-0"
          >
            <div
              *ngFor="
                let organizer of event?.data?.organisers
                  | event_organizer : '127'
              "
              class="mt-12"
            >
              <mat-card
                (click)="event.data.member_view(organizer.member_id)"
                class="example-card pb-0"
                style="width: 250px; padding: 0px !important; cursor: pointer"
              >
                <mat-card-header class="head">
                  <div mat-card-avatar>
                    <img
                      mat-card-image
                      (error)="errorHandler($event)"
                      src="{{ organizer.photo_url }}"
                      alt="{{ organizer.name }}"
                    />
                  </div>
                  <mat-card-title class="namesize">{{
                    organizer.name
                  }}</mat-card-title>
                  <mat-card-subtitle>{{
                    organizer.member_id
                  }}</mat-card-subtitle>
                </mat-card-header>
              </mat-card>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card
        *ngIf="event.data.enable_fieldworkers"
        class="example-card cardstle"
      >
        <mat-card-header class="accent">
          <mat-card-title class="mt-4">{{
            event?.data?.event_subgroup?.param_2 || "களப்பணி ஆற்றியவர்கள்"
              | translate
          }}</mat-card-title>
        </mat-card-header>
        <mat-card-content class="primary-50">
          <div
            fxLayout="row flex-wrap"
            class="p-16 pt-0 line-height-1.75 mr-12 ml-12 mb-12 mt-0"
          >
            <div
              *ngFor="
                let organizer of event?.data?.organisers
                  | event_organizer : '128'
              "
              class="mt-12"
            >
              <mat-card
                class="example-card pb-0"
                (click)="event.data.member_view(organizer.member_id)"
                style="width: 250px; padding: 0px !important; cursor: pointer"
              >
                <mat-card-header class="head">
                  <div mat-card-avatar>
                    <img
                      mat-card-image
                      (error)="errorHandler($event)"
                      src="{{ organizer.photo_url }}"
                      alt="{{ organizer.name }}"
                    />
                  </div>
                  <mat-card-title class="namesize">{{
                    organizer.name
                  }}</mat-card-title>
                  <mat-card-subtitle>{{
                    organizer.member_id
                  }}</mat-card-subtitle>
                </mat-card-header>
              </mat-card>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card
        *ngIf="event.data.enable_supporter_btn"
        class="example-card cardstle"
      >
        <mat-card-header class="accent">
          <mat-card-title class="mt-4">ஆதரிப்பவர்கள்</mat-card-title>
        </mat-card-header>
        <mat-card-content class="primary-50">
          <div
            fxLayout="row flex-wrap"
            class="p-16 pt-0 line-height-1.75 mr-12 ml-12 mb-12 mt-0"
          >
            <div
              *ngFor="
                let organizer of event?.data?.organisers
                  | event_organizer : '129'
              "
              class="mt-12"
            >
              <mat-card
                class="example-card pb-0"
                style="width: 250px; padding: 0px !important"
              >
                <mat-card-header class="head">
                  <div mat-card-avatar>
                    <img
                      mat-card-image
                      src="{{ organizer.photo_url }}"
                      alt="{{ organizer.name }}"
                    />
                  </div>
                  <mat-card-title class="namesize">{{
                    organizer.name
                  }}</mat-card-title>
                  <mat-card-subtitle>{{
                    organizer.member_id
                  }}</mat-card-subtitle>
                </mat-card-header>
              </mat-card>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card
        *ngIf="event.data.enable_opponent_btn"
        class="example-card cardstle"
      >
        <mat-card-header class="accent">
          <mat-card-title class="mt-4">ஆதரிப்பவர்கள்</mat-card-title>
        </mat-card-header>
        <mat-card-content class="primary-50">
          <div
            fxLayout="row flex-wrap"
            class="p-16 pt-0 line-height-1.75 mr-12 ml-12 mb-12 mt-0"
          >
            <div
              *ngFor="
                let organizer of event?.data?.organisers
                  | event_organizer : '130'
              "
              class="mt-12"
            >
              <mat-card
                class="example-card pb-0"
                style="width: 250px; padding: 0px !important"
              >
                <mat-card-header class="head">
                  <div mat-card-avatar>
                    <img
                      mat-card-image
                      src="{{ organizer.photo_url }}"
                      alt="{{ organizer.name }}"
                    />
                  </div>
                  <mat-card-title class="namesize">{{
                    organizer.name
                  }}</mat-card-title>
                  <mat-card-subtitle>{{
                    organizer.member_id
                  }}</mat-card-subtitle>
                </mat-card-header>
              </mat-card>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card
        *ngIf="event.data.enable_responsibilities_btn"
        class="example-card cardstle"
      >
        <mat-card-header class="accent">
          <mat-card-title class="mt-4">{{
            event?.data?.event_subgroup?.param_3 || "நிகழ்வு பொறுப்பாளர்கள்"
              | translate
          }}</mat-card-title>
        </mat-card-header>
        <mat-card-content class="primary-50">
          <div
            fxLayout="row flex-wrap"
            class="p-16 pt-0 line-height-1.75 mr-12 ml-12 mb-12 mt-0"
          >
            <div
              *ngFor="
                let organizer of event?.data?.organisers
                  | event_organizer : '126'
              "
              class="mt-12"
            >
              <mat-card
                class="example-card pb-0"
                style="width: 250px; padding: 0px !important"
              >
                <mat-card-header class="head">
                  <div mat-card-avatar>
                    <img
                      mat-card-image
                      src="{{ organizer.photo_url }}"
                      alt="{{ organizer.name }}"
                    />
                  </div>
                  <mat-card-title class="namesize">{{
                    organizer.name
                  }}</mat-card-title>
                  <mat-card-subtitle>{{
                    organizer.member_id
                  }}</mat-card-subtitle>
                </mat-card-header>
              </mat-card>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card class="example-card cardstle">
        <mat-card-header class="accent">
          <mat-card-title class="mt-4">{{
            event?.data?.event_subgroup?.param_4 || "கலந்து கொண்டவர்கள்"
              | translate
          }}</mat-card-title>
        </mat-card-header>
        <mat-card-content class="primary-50">
          <div class="p-12">
            <p>{{ event?.data?.num_participants }}</p>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card class="example-card cardstle">
        <mat-card-header class="accent">
          <mat-card-title class="mt-4">வா.சாவடிகள்</mat-card-title>
        </mat-card-header>
        <mat-card-content class="primary-50">
          <div class="p-12" fxLayout="column">
            <div *ngFor="let booth of event?.data?.event_booths">
              {{ booth.booth_number }}, {{ booth.booth }}
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card
        *ngIf="event.data.enable_uploads_btn"
        class="example-card cardstle"
      >
        <mat-card-header class="accent">
          <mat-card-title class="mt-4">{{
            event?.data?.event_subgroup?.param_5 || "கோப்புகள்" | translate
          }}</mat-card-title>
        </mat-card-header>
        <mat-card-content class="primary-50">
          <div
            fxLayout="row flex-wrap"
            class="p-16 pt-0 line-height-1.75 mr-12 ml-12 mb-12 mt-0"
          >
            <mat-card
              *ngFor="let file of event?.data?.event_files"
              class="example-card"
              style="width: 200px; text-align: center"
            >
              <s3-image
                *ngIf="isImage(file)"
                mat-card-image
                src="{{ API_FILES }}?dir=eventFiles/{{
                  event?.data?.event_id
                }}&name={{ file }}"
                alt=""
                style="width: 200px"
                (click)="zoomImage(event?.data)"
              >
              </s3-image>

              <s3-file
                *ngIf="!isImage(file)"
                mat-card-image
                src="{{ API_FILES }}?dir=eventFiles/{{
                  event?.data?.event_id
                }}&name={{ file }}"
                alt=""
                style="width: 150px"
              >
              </s3-file>
            </mat-card>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
